// extracted by css-extract-rspack-plugin
export default {"wrapper":"PricePerClickLabel-module__wrapper--my26d","icon":"PricePerClickLabel-module__icon--PFUpR"};